import moment from 'moment-timezone';
import store from '@/store';
import enums from '@/utils/enums';
import sleep from '@/utils/sleep';
import save from './save';
import { APP, USER, UNIT, CONFIG } from '../../utils/constants';
import formatDetails from './formatDetails';
import mobileDeviceCheck from '@/utils/mobileDeviceCheck';
import { getAccessType, logout } from '@/services/auth';
import logTraceEnums from '../../utils/logTraceEnums';
const logTraceActions = logTraceEnums.actions;
const withoutUnitActions = [
  logTraceActions.login.description,
  logTraceActions.loginByAdmin.description,
  logTraceActions.firstAccess.description,
  logTraceActions.passwordChangeByCode.description,
  logTraceActions.forgotPassword.description,
  logTraceActions.bexsServerError.description,
  logTraceActions.changeRepeatedEmail.description,
];

const logQueue = [];
let queuePromise = null;
let lastInteraction = null;

const addToQueue = (body, offline) => {
  try {
    logQueue.push(body);

    checkTimeOut();
    if (!queuePromise && !offline) {
      queuePromise = async () => {
        while (logQueue.length > 0) {
          const data = logQueue.shift();
          await save(data).catch((err) => {
            logQueue.unshift(data);
            queuePromise = null;
            throw err;
          });
        }
        queuePromise = null;
      };

      queuePromise();
    }

    return queuePromise;
  } catch (err) {
    queuePromise = null;
    throw err;
  }
};

const checkTimeOut = () => {
  const logoutTimeOut = store.getters[CONFIG.GET_SHARED].LOGOUT_TIMEOUT;

  if (logoutTimeOut != null) {
    const now = moment();

    if (lastInteraction == null) {
      lastInteraction = now;
    }

    const diffDuration = now.diff(lastInteraction, 'minutes');
    if (diffDuration >= logoutTimeOut) {
      logout();
    } else {
      lastInteraction = now;
    }
  }
};

let resendTimerMs = -1;
const retryLogDispatch = async () => {
  if (resendTimerMs <= 0) {
    resendTimerMs =
      store.getters[CONFIG.GET_LOGTRACE_WAIT_MS] > 1000
        ? store.getters[CONFIG.GET_LOGTRACE_WAIT_MS]
        : 10000;
    await sleep(resendTimerMs);
    resendTimerMs = -1;
    const user = store.getters[USER.GET_USER];
    if (user) {
      dispatchLogList(user);
    } else {
      //? await for a period of time
      retryLogDispatch();
    }
  }
};

const dispatchLogList = (user) => {
  //? cleans the logList recursively
  const log = logList.pop();
  log.userInfo = user;
  logTrace(log);
};

let lastTrace = null;
let lastDetails = null;
let lastUserInfo = null;
let logList = [];
let logtraceServiceStartedAt = new moment();
const testLogQueue = () => {
  //! if you want to use this test, add a time (milliseconds) into tenantConfig (mongoDB) navigationRules.logTraceWaitMs
  const logtraceWaitTimeMs = store.getters[CONFIG.GET_LOGTRACE_WAIT_MS];
  return (
    moment().diff(logtraceServiceStartedAt, 'milliseconds') < logtraceWaitTimeMs
  );
};

const logTrace = (
  {
    action = null,
    details = {},
    userInfo = {},
    reCreateLast = false,
    contractId = null,
    date = null,
  } = {},
  offline = false
) => {
  try {
    if (reCreateLast) {
      action = lastTrace;
      details = lastDetails;
      userInfo = lastUserInfo;
    }
    if (!date) {
      date = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    }

    const validation = action.details;
    if (validation) details = formatDetails(validation, details, action);

    const user = store.getters[USER.GET_USER]
      ? store.getters[USER.GET_USER]
      : userInfo;

    if (testLogQueue() || !user) {
      //? adds to the logList
      logList.push({
        action,
        details,
        userInfo,
        reCreateLast: false,
        contractId,
        date,
      });
      retryLogDispatch();
      return null;
    } else if (logList.length > 0) {
      dispatchLogList(user);
    }

    const admin = store.getters[APP.GET_ADMIN_PREVIEW];
    const selectedUnit = store.getters[UNIT.GET_SELECTED];

    let contract;
    let product;

    if (contractId) {
      const { id, type } = selectedUnit.contracts.find(
        (o) => o.id === contractId
      );
      contract = {
        id: String(id),
        type,
      };

      product = {
        title: selectedUnit.product.title,
        block: selectedUnit.block.title,
        unit: selectedUnit.unit.code,
      };
    } else if (selectedUnit) {
      const { id, type } = selectedUnit.contracts.find(
        (o) => o.isValid || (o.type === 'Indireto')
      );
      contract = {
        id: String(id),
        type,
      };

      product = {
        title: selectedUnit.product.title,
        block: selectedUnit.block.title,
        unit: selectedUnit.unit.code,
      };
    }

    if (!action || !action.id) {
      action = logTraceActions.undefinedLog;
    }

    const body = {
      details,
      product,
      contract,
      date,
      user: {
        fullName: user.fullName,
        username: user.username,
        email: user.email,
        userRole: user.userRole,
      },
      action: action.id,
      description: action.description,
      device: mobileDeviceCheck() ? 'mobile' : 'desktop',
      admin: admin ? admin.username : null,
      accessType: getAccessType(),
    };

    lastTrace = action;
    lastDetails = details;
    lastUserInfo = userInfo;

    if (!selectedUnit && !withoutUnitActions.includes(action.description)) {
      return null;
    }
    return addToQueue(body, offline);
  } catch (err) {
    // console.log(err)
  }
};

export default logTrace;



// WEBPACK FOOTER //
// ./src/services/logTrace/index.js